import { PageHead } from '../reporting/PageHead';
import { Panel } from '../dashboard/ui';

export function CustomerFeedback() {
  return (
    <section className="report">
      <PageHead crumb="Reporting / Customer feedback" title="Customer feedback" />
      <Panel title="Ratings & feedback" subtitle="Customer delivery ratings">
        <div className="empty-note">
          <strong>No customer feedback data available.</strong>
          <p className="muted">
            The source <code>team_member_ratings</code> table is currently empty — no delivery
            ratings or feedback are being captured/synced from Locate2u for this team. Once ratings
            start flowing, this page will show average rating, rating distribution, and recent
            comments by driver and region.
          </p>
        </div>
      </Panel>
    </section>
  );
}
